export default "__VITE_ASSET__CXid3$LD__"